module.exports = __webpack_public_path__ + "img/import_blue.e08aff11.svg";